module.exports = __webpack_public_path__ + "img/ave04.83d049ed.png";